
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
    apiKey: "AIzaSyCJBp-0Wmi-PfboH5ODwAFCsg5ruq7edGU",
    authDomain: "nadia-healthcare-service-fbfac.firebaseapp.com",
    projectId: "nadia-healthcare-service-fbfac",
    storageBucket: "nadia-healthcare-service-fbfac.appspot.com",
    messagingSenderId: "803600996516",
    appId: "1:803600996516:web:9bb44fd0b83c62d326ee31",
    measurementId: "G-W79QKVJXXF"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;